export var SelectionStatus;
(function (SelectionStatus) {
    SelectionStatus["Settled"] = "Settled";
    SelectionStatus["Unsettled"] = "Unsettled";
})(SelectionStatus || (SelectionStatus = {}));
//# sourceMappingURL=SelectionStatus.js.map